import type { ProductImageEntry } from "./types";

const entry = (
  id: string,
  module: string,
  opens: string,
  altSv: string,
  altEn: string,
  showsSv: string,
  showsEn: string,
  provesSv: string,
  provesEn: string,
): ProductImageEntry => ({
  id,
  module,
  area: "schedule",
  opens,
  setup: ["Öppna det sparade DEV-resultatet i Planering"],
  scenario: "S1",
  visual: { variant: 0 },
  text: {
    sv: { alt: altSv, shows: showsSv, proves: provesSv },
    en: { alt: altEn, shows: showsEn, proves: provesEn },
  },
  use: ["pages/Plattform.tsx"],
});

export const CALENDAR_MORE_DETAIL_CATALOGUE: readonly ProductImageEntry[] = [
  entry(
    "planning.calendar.details-drawer",
    "Kalenderdetaljer",
    "Planering → Kalender → Detaljer",
    "Detaljpanel med kalenderns vykontroller",
    "Details panel with calendar view controls",
    "Öppna panelen för att nå kalenderns detaljlägen.",
    "Open the panel to reach calendar detail modes.",
    "Panelen visar detaljlägena som finns i den valda kalendern.",
    "The panel shows the detail modes available for this calendar.",
  ),
  entry(
    "planning.calendar.luckor-lane",
    "Otilldelade i kalendern",
    "Planering → Kalender → Detaljer → Otilldelade",
    "Kalender med otilldelade besök i sina tillåtna tidsfönster",
    "Calendar with unassigned visits in their allowed time windows",
    "Granska otilldelade besök samlade ovanför medarbetarnas kalender.",
    "Review unassigned visits grouped above the employee calendar.",
    "Vyn visar otilldelade besök från den valda lösningen.",
    "The view shows unassigned visits from the selected solution.",
  ),
  entry(
    "planning.calendar.visit-inspector",
    "Besöksdetaljer",
    "Planering → Kalender → välj ett besök",
    "Detaljpanel för ett planerat besök",
    "Detail panel for a scheduled visit",
    "Granska besökets schemalagda tid och längd.",
    "Review the visit’s scheduled time and duration.",
    "Panelen visar detaljer för det valda kalenderbesöket.",
    "The panel shows details for the selected calendar visit.",
  ),
  entry(
    "planning.calendar.employee-inspector",
    "Medarbetardetaljer i kalendern",
    "Planering → Kalender → öppna en medarbetares radmeny",
    "Detaljpanel för medarbetaren och dennes schemapass",
    "Detail panel for an employee and their scheduled shifts",
    "Granska medarbetarens pass som visas på kalenderns rad.",
    "Review the employee’s shifts shown on the calendar row.",
    "Panelen visar pass från den valda kalenderns schema.",
    "The panel shows shifts from the selected calendar schedule.",
  ),
  entry(
    "planning.calendar.grouped-roles",
    "Kalender grupperad per roll",
    "Planering → Kalender → Gruppering → Medarbetarroll",
    "Kalender med medarbetarrader grupperade efter roll",
    "Calendar with employee rows grouped by role",
    "Visa kalenderns medarbetare under sina rollgrupper.",
    "View calendar employees within their role groups.",
    "Grupperingen använder rollerna som finns på kalenderns medarbetare.",
    "The grouping uses the roles present on calendar employees.",
  ),
  entry(
    "planning.calendar.break-filter",
    "Rastlager i kalendern",
    "Planering → Kalender → Filter → Paus",
    "Kalender filtrerad till rastpass",
    "Calendar filtered to break events",
    "Visa de rastpass som finns i det valda kalenderresultatet.",
    "Show the break events present in the selected calendar result.",
    "Filtret visar bara raster som finns i kalenderns sparade data.",
    "The filter shows only breaks present in the calendar’s saved data.",
  ),
];
